<template>
   <v-card>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="showPlusses=!showPlusses" :value="this.showPlusses" :caption="this.showPlusses ? 'Кратко' : 'Подробно'" :expandable="true">
      <span> Поставки ({{plusses.length}}):
      <b>{{formats.blank(plussesSum, formats.formatNumber)}} руб.</b></span>
    </v-panel-title>
    <v-card-text v-show="showPlusses">
      <v-list two-line dense>
        <template v-for="(item, i) in plusses">
          <v-list-tile :key="'p' + i">
             <v-list-tile-content>
              <v-list-tile-title  v-html="'Поставка ' + '<b>' + item.amount + '</b>' + ' руб.'"></v-list-tile-title>
              <v-list-tile-sub-title >{{item.note}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
            <v-list-tile-action-text>{{formats.blank(item.date, formats.formatDate)}}</v-list-tile-action-text>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>        
    </v-card-text>
  </v-card>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="showMinuses=!showMinuses" :value="this.showMinuses" :caption="this.showMinuses ? 'Кратко' : 'Подробно'" :expandable="true">
      <span>Платежи ({{minuses.length}}):
      <b>{{formats.blank(minusesSum, formats.formatNumber)}}  руб.</b></span>
    </v-panel-title>
    <v-card-text v-show="showMinuses">
      <v-list two-line dense>
        <template v-for="(item, i) in minuses">
          <v-list-tile :key="'m' + i">
             <v-list-tile-content>
              <v-list-tile-title  v-html="'Платеж ' + '<b>' + item.amount + '</b>' + ' руб.'"></v-list-tile-title>
              <v-list-tile-sub-title >{{item.note}}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
            <v-list-tile-action-text>{{formats.blank(item.date, formats.formatDate)}}</v-list-tile-action-text>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>        
    </v-card-text>
  </v-card>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="showParams=!showParams" :value="this.showParams" :caption="this.showParams ? 'Кратко' : 'Подробно'" :expandable="true">
      Параметры расчета:
    <div>
      <span>{{params.startType === 'RELEASE' ? 'Дата поставки' : 'Начало просрочки'}}: <b>{{ formats.blank(params.start, formats.formatDate)}}</b></span> - <span><b>{{ formats.blank(params.end, formats.formatDate)}}</b></span>
      <br/>
      <span>{{params.rateType === 'DAY' && params.rates && params.rates.length === 1 ? `Ставка ${ this.formatPercent(params.rates[0].percent)} в день` : `Сложная ставка`}}</span>
      <span>{{`Отсрочка платежа ${ formats.blank(params.lateDays, formats.formatNumber)}`}}</span>
      <br/>
      <b><span>{{params.minusType !== 'BASE_ONLY' || params.periodType !== 'DAYS_365' || params.dutyType !== "ARBITR" ? 'Не стандартные параметры' : ''}}</span></b>
    </div>  
    </v-panel-title>
    <v-card-text v-show="showParams" class="pt-0">
    <v-layout mt-3 row wrap justify-left>
      <v-flex sm4 xs12>
      <v-select
        label="Начало расчета"
        v-model="params.startType"
        :items="startDayItems"
        item-text="text"
        item-value="value"
      ></v-select>
      </v-flex>
      <v-flex sm4 xs5>
        <v-date-field 
          v-if="params.startType!=='RELEASE'"
          label="Начало просрочки"
          v-model="params.start"
          :rules="startDateRules"
          :error-messages="errorDateOrder()"
          :hint="hints.startDate"
          :min="getFirstStartDateString()"
          :calendarOnly="isCalendarOnly"
        ></v-date-field>
        <v-date-field
          v-if="params.startType==='RELEASE'"
          label="Дата поставки"
          v-model="params.start"
          :rules="startDateReleaseRules"
          :error-messages="errorDateOrder()"
          :hint="hints.startDateRelease"
          :min="getFirstStartDateString()"
          :calendarOnly="isCalendarOnly"
        ></v-date-field>
      </v-flex>
      <v-flex sm3 xs5>
        <v-date-field
          label="Конец"
          v-model="params.end"
          :rules="endDateRules"
          :error-messages="errorDateOrder()"
          :hint="hints.endDate"
          :calendarOnly="isCalendarOnly"
        ></v-date-field>
      </v-flex>
      <v-flex px-2 sm12 xs12>
      <v-subheader value.calcType>
        Процентные ставки:
        <v-btn icon @click="addPercent()">
          <v-icon>add</v-icon>
        </v-btn>
      </v-subheader>
      </v-flex>
      <v-flex sm12 xs12>
      <v-card v-for="(item, i) in rates" :key="'rate' + i">
        <v-layout row wrap justify-space-around>
          <v-flex sm2 xs3>
            <v-text-field
              :disabled="isDisabledRate(i)"
              label="с (дня)" v-model="item.from">
            </v-text-field>
          </v-flex>
          <v-flex sm2 xs3>
            <v-number-field
              label="ставка, %" v-model="item.percent">
            </v-number-field>
          </v-flex>
          <v-flex pt-2 sm1 xs2>
            <v-btn :disabled="isDisabledRate(i)"
icon small @click="deletePercent(item)">
              <v-icon small>clear</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
      </v-flex>
      <v-flex mr-4 sm5 xs12 >
      <v-select
        label="Размер ставки"
        v-model="params.rateType"
        :items="rateTypeItems"
        item-text="text"
        item-value="value"
      ></v-select>
      </v-flex>
      <v-flex mr-4 sm5 xs12 >
        <v-number-field
          label="Отсрочка оплаты, в днях."
          v-model="params.lateDays"
        >
        </v-number-field>
      </v-flex>
      <v-flex mr-4 sm5 xs12 >
        <v-select
          label="Очередность погашения"
          v-model="params.minusType"
          :items="minusTypeItems"
          item-text="text"
          item-value="value"
        ></v-select>
      </v-flex>
      <v-flex mr-4 sm5 xs12>
      <v-select
        label="Период определять"
        v-model="params.periodType"
        :items="periodTypeItems"
        item-text="text"
        item-value="value"
      ></v-select>
      </v-flex>
      <v-flex mr-4 sm10 xs12>
      <v-select
        label="Расчет гос.пошлины"
        v-model="params.dutyType"
        :items="calcDutyItems"
        item-text="text"
        item-value="value"
      ></v-select>
      </v-flex>      
      <v-spacer/>
    </v-layout>
  </v-card-text>
  </v-card>


  </v-card>
</v-card>
</template>

<script>
  import vDateField from '../../common/DateField.vue'
  import vNumberField from '../../common/NumberField.vue'
  import vPanelTitle from '../../info/PanelTitle'
  import apimix from '../../common/apimix'

  import { mapGetters } from 'vuex'
  import moment from 'moment'
  // import dialogs from '../../../components/common/dialogs'
  // import vCSVLoader from './CalcCSVLoader'

  // Const of valid dates
  const FIRST_STARTDATE_STRING = '1995-01-01'
  const HINT_STARTDATE = 'Следующий день после срока оплаты'
  const HINT_STARTDATE_RELEASE = 'Дата поставки, след. день 1й день просрочки'
  const HINT_ENDDATE = 'День фактического погашения долга либо иная дата, на которую рассчитывается неустойка, если долг не погашен'

  export default {
    name: 'calc-panel',
    components: {vDateField, vNumberField, vPanelTitle},
    mixins: [apimix],
    data: () => ({
      fillHeight: true,
      refresh: false,
      localValue: null,
      valid: true,
      showPlusses: false,
      showMinuses: false,
      showParams: false,
      showDetails: false,
      hints: {
        startDate: HINT_STARTDATE,
        startDateRelease: HINT_STARTDATE_RELEASE,
        endDate: HINT_ENDDATE
      },
      startDateRules: [
        v => !!v || HINT_STARTDATE
      ],
      startDateReleaseRules: [
        v => !!v || HINT_STARTDATE_RELEASE
      ],
      endDateRules: [
        v => !!v || HINT_ENDDATE
      ],
      opsDateRules: [
        v => !!v || 'Заполните дату'
      ],
      opsAmountRules () {
        return [
          v => !!v || 'Заполните сумму'
        ]
      },
      sumRules: [
        v => !!v || 'Заполните величину задолженности'
      ],
      currencyItems: [
        {text: 'рублей', value: 'RUB'},
        {text: 'долларов США', value: 'USD'},
        {text: 'евро', value: 'EUR'}
      ],
      startDayItems: [
        {text: 'Начало просрочки', value: 'DELAY'},
        {text: 'Дата поставки', value: 'RELEASE'}
      ],
      periodTypeItems: [
        {text: 'В календарных днях', value: 'DAYS_365'},
        {text: 'Из расчета 360 дней в году', value: 'DAYS_360'}
      ],
      minusTypeItems: [
        {text: 'Только основной долг', value: 'BASE_ONLY'},
        {text: 'Основной долг, неустойка', value: 'BASE_PRIOR'},
        {text: 'Неустойка, основной долг', value: 'PERCENT_PRIOR'}
      ],
      rateTypeItems: [
        // {text: 'цена договора', value: 'BASE_OVERALL'},
        {text: 'Cтавка в годовых процентах', value: 'YEAR'},
        {text: 'Cтавка в процентах за день', value: 'DAY'}
      ],
      baseTypeItems: [
        // {text: 'цена договора', value: 'BASE_OVERALL'},
        {text: 'на сумму просроченного платежа', value: 'BASE_LATE_PAYMENT'}
      ],
      calcTypeItems: [
        {text: 'Проценты по ст. 395 ГК РФ', value: 'PERCENT_395'},
        {text: 'Проценты по ст. 317.1 ГК РФ', value: 'PERCENT_317'},
        {text: 'Договорная неустойка', value: 'CONTRACT'}
      ],
      calcDutyItems: [
        {text: 'Cумма гос.пошлины для арбитражных судов', value: 'ARBITR'},
        {text: 'Cумма гос.пошлины для судов общей юрисдикции', value: 'COMMON'}
      ]
    }),
    mounted () {
      this.clear()
    },
    props: {
      value: {
        type: Object,
        default: function () {
          return {
            params: {
              start: null,
              end: null,
              lateDays: 0,
              rates: [{from: 1, percent: 0.1}],
              calcType: 'CONTRACT',
              startType: 'DELAY',
              periodType: 'DAYS_365',
              minusType: 'BASE_ONLY',
              rateType: 'DAY',
              dutyType: 'ARBITR'
            },
            loans: [],
            pays: [],
            details: [],
            result: {
              sum: null,
              percent: null,
              total: null,
              duties: null
            }
          }
        }
      }
    },
    computed: {
      ...mapGetters({
      }),
      params () {
        return this.value && this.value.params ? this.value.params : {}
      },
      plusses () {
        return this.value.loans
      },
      minuses () {
        return this.value.pays
      },
      minusesSum () {
        return (this.value.pays.reduce((s, i) => s + i.amount, 0))
      },
      plussesSum () {
        return (this.value.loans.reduce((s, i) => s + i.amount, 0))
      },
      rates () {
        return this.value.params.rates
      },
      isAreaVisible () {
        if (!(this.value && this.value.startDate && this.value.endDate)) {
          return false
        }
        var areaStart = moment('2015-06-01')
        var areaEnd = moment('2016-08-01')
        var start = moment(this.value.startDate)
        var end = moment(this.value.endDate)
        if ((start.isBefore(areaStart) && end.isBefore(areaStart)) ||
          (areaEnd.isBefore(start) && areaEnd.isBefore(end))) {
          return false
        }
        return true
      },
      isMobile () {
        return this.$vuetify.breakpoint.smAndDown
      },
      isCalendarOnly () {
        return this.isMobile
      }
    },
    methods: {
      updateValid (value) {
        this.valid = value
      },
      errorDateOrder () {
        if (this.value != null &&
          this.value.startDate != null &&
          this.value.endDate != null) {
          if (!moment(this.value.startDate).isBefore(moment(this.value.endDate))) {
            return ['Ошибочный порядок дат']
          }
        }
        return []
      },
      errorOpsDateOrder (v) {
        if (!moment(v).isValid()) {
          return []
        }
        var date = moment(v)
        if (this.value != null &&
          this.value.startDate != null &&
          this.value.endDate != null) {
          if (!(!moment(this.value.startDate).isAfter(date) && date.isBefore(moment(this.value.endDate)))) {
            return ['Ошибочный порядок дат']
          }
        }
        return []
      },
      getFirstStartDateString () {
        return FIRST_STARTDATE_STRING
      },
      addPercent () {
        if (!this.rates) {
          this.rates = []
        }
        this.rates.push({from: null, to: null, percent: null})
      },
      deletePercent (item) {
        this.rates.splice(this.rates.indexOf(item), 1)
      },
      isDisabledRate (i) {
        return i === 0
      },
      submit () {
        if (this.$refs.form.validate()) {
          if (!this.isAreaVisible) {
            this.value.area = null
          }
          var request = JSON.parse(JSON.stringify(this.localValue))
          this.$store.dispatch('calculate', request)
          this.$emit('submit')
        }
      },
      clear () {
        this.refresh = true
      },
      formatPercent (num) {
        return num != null ? (num).toLocaleString({minimumFractionDigits: 2, maximumFractionDigits: 2}) + '%' : '-'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CalcPanel.vue?afd1caa0